// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"95":"pajination","710":"blogpostContent","956":"scrollToTop","977":"swiperCarousel"}[chunkId] || chunkId) + "." + {"95":"270875e565ee9c515f50","172":"8ebe3c7a29f0b74fc8f9","710":"df9d83715db9c240850d","956":"33e73b201f912936b55e","977":"5d2a923a7ac61d04951c"}[chunkId] + ".js";
};